import React from "react";
import Icon from "../../../../YourAIAgents/components/components/icon";

const closeButtonStyle = {
  position: "absolute",
  right: 0,
  top: 0,
  width: "24px",
  height: "24px",
  padding: 0,
  border: "none",
  background: "transparent",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
};

const ModalCloseButton = ({ onClick }) => (
  <button
    type="button"
    aria-label="Close modal"
    style={closeButtonStyle}
    onClick={onClick}
  >
    <Icon id="close" />
  </button>
);

export default ModalCloseButton;
